<apx-chart
  #chart
  *ngIf="chartOptions"
  [series]="chartOptions.series"
  [chart]="chartOptions.chart"
  [colors]="chartOptions.colors"
  [yaxis]="chartOptions.yaxis"
  [grid]="chartOptions.grid"
  [dataLabels]="chartOptions.dataLabels"
  [markers]="chartOptions.markers"
  [stroke]="chartOptions.stroke"
  [xaxis]="chartOptions.xaxis"
  [tooltip]="chartOptions.tooltip"
></apx-chart>
